import React from 'react';
import cx from 'classnames';
import s from './StepIndicators.module.css';

const steps = ['step1', 'step2', 'step3', 'step4'];

export const StepIndicators = ({ step }) => (
    <div className={s.indicators}>
        {steps.map((item, index) => {
            const isPassed = step >= index;
            const isActive = step === index;
            return (
                <div
                    key={item}
                    className={cx(s.indicator, {
                        [s.notPassed]: !isPassed,
                        [s.active]: isActive,
                    })}
                >
                    <div className={s.dot} />
                </div>
            );
        })}
    </div>
);
